var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz2__customizer"},[_c('transition',{attrs:{"name":"cz2__fade"}},[(_vm.splashShown)?_c('splash'):_vm._e()],1),_c('transition',{attrs:{"name":"cz2__fade"}},[_c('steps')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }